<!-- <ion-range [value]="mappingsWizard.discretize(value, 10)*100" style="height: 3vh; margin-top: 3px;"></ion-range> -->
<div class="bar-container" *ngIf="!normalized">
  <div part="bar" class="background-bar"></div>

  <div class="target-cursor" [ngStyle]="{'margin-left': (target / (resolution - 1))*100 + '%', 'visibility' : target === undefined ? 'hidden' : 'visible'}">
    <img src="/assets/icons/cursor-target.svg" [ngStyle]="{'filter': valueInsideTarget() ? 'hue-rotate(120deg)' : 'hue-rotate(0deg)'}">
  </div>

  <div class="movement-cursor" [ngStyle]="{'margin-left': (value / (resolution - 1))*100 + '%'}"></div>
  <div class="capturing-ring-1" [ngStyle]="{'margin-left': (value / (resolution - 1))*100 + '%','visibility' : capturing ? 'visible' : 'hidden'}"></div>
</div>

<div class="bar-container" *ngIf="normalized">
  <div part="bar" class="background-bar"></div>

  <div class="target-cursor" [ngStyle]="{'margin-left': mappingsWizard.discretize(target, resolution)*100 + '%', 'visibility' : target === undefined ? 'hidden' : 'visible'}">
    <img src="/assets/icons/cursor-target.svg" [ngStyle]="{'filter': valueInsideTarget() ? 'hue-rotate(120deg)' : 'hue-rotate(0deg)'}">
  </div>

  <div class="movement-cursor" [ngStyle]="{'margin-left': mappingsWizard.discretize(value, resolution)*100 + '%'}"></div>
  <div class="capturing-ring-1" [ngStyle]="{'margin-left': mappingsWizard.discretize(value, resolution)*100 + '%','visibility' : capturing ? 'visible' : 'hidden'}"></div>
</div>


